import { BRAND } from '../../config/brand';
import './Legal.css';

function LegalContact() {
  return (
    <main className="legal-page">
      <div className="container">
        <div className="legal-card">
          <h1 className="legal-title">Contact</h1>

          <div className="contact-sections">
            {/* Company Info Section */}
            <div className="contact-section">
              <h2 className="contact-section-title">Company Information</h2>
              <div className="contact-row">
                <span className="contact-label">Company</span>
                <span className="contact-value">{BRAND.legal.companyName}</span>
              </div>
              <div className="contact-row">
                <span className="contact-label">Company ID</span>
                <span className="contact-value">{BRAND.legal.companyId}</span>
              </div>
              <div className="contact-row">
                <span className="contact-label">Registered Address</span>
                <span className="contact-value">{BRAND.legal.address}</span>
              </div>
              <div className="contact-row">
                <span className="contact-label">US Mailing Address</span>
                <span className="contact-value">{BRAND.legal.mailingAddress}</span>
              </div>
              <div className="contact-row">
                <span className="contact-label">Phone</span>
                <span className="contact-value">
                  <a className="legal-link" href={`tel:${BRAND.legal.phone}`}>{BRAND.legal.phone}</a>
                </span>
              </div>
              <div className="contact-row">
                <span className="contact-label">WhatsApp</span>
                <span className="contact-value">
                  <a className="legal-link" href={BRAND.legal.whatsapp} target="_blank" rel="noopener noreferrer">Chat with us</a>
                </span>
              </div>
            </div>

            {/* Support Section */}
            <div className="contact-section">
              <h2 className="contact-section-title">Support</h2>
              <div className="contact-row">
                <span className="contact-label">Email</span>
                <span className="contact-value">
                  <a className="legal-link" href={`mailto:${BRAND.supportEmail}`}>{BRAND.supportEmail}</a>
                </span>
              </div>
              <p className="contact-note">
                For support, billing, or legal requests. Please include your order ID if applicable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default LegalContact;
